export class CustomPurchaseWindow {
  //IF THIS IS NULL, CAN BE PURCHASED ANYTIME IT IS VISIBLE
  public start: number;
  public end: number;
  public timeOnLastDay: string;
  constructor(start: number, end: number, timeOnLastDay: string) {
    this.start = start;
    this.end = end;
    this.timeOnLastDay = timeOnLastDay;
  }

  toJSON() {
    return {
      start: this.start,
      end: this.end,
      timeOnLastDay: this.timeOnLastDay
    };
  }
}
